import { Center, Stack, Text, Title } from '@mantine/core';

export function ComingSoonPage({ name }: { name: string }) {
  return (
    <Center h="60vh">
      <Stack align="center" gap="xs">
        <Title order={3}>{name}</Title>
        <Text c="dimmed">This section is not built yet. It lands in a later slice.</Text>
      </Stack>
    </Center>
  );
}
